"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ProductSuppliersGroup_1 = require("../model/ProductSuppliersGroup");

var ProductSuppliersGroupConverter_1 = require("./ProductSuppliersGroupConverter");

var ProductSuppliersGroupConverterImpl =
/*#__PURE__*/
function (_ProductSuppliersGrou) {
  _inherits(ProductSuppliersGroupConverterImpl, _ProductSuppliersGrou);

  function ProductSuppliersGroupConverterImpl() {
    _classCallCheck(this, ProductSuppliersGroupConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProductSuppliersGroupConverterImpl).apply(this, arguments));
  }

  _createClass(ProductSuppliersGroupConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new ProductSuppliersGroup_1.ProductSuppliersGroup(ProductSuppliersGroup_1.ProductSuppliersGroup.schema.productId.valueOf(conversions.toClassReferenceId(source.productId)), ProductSuppliersGroup_1.ProductSuppliersGroup.schema.supplierIds.valueOf(conversions.asClassReferenceIdsSet(source, 'supplierIds')));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        productId: conversions.toDocumentReferenceId(source.productId),
        supplierIds: conversions.asObjectArray(source, 'supplierIds', function (id) {
          return conversions.toDocumentReferenceId(id);
        })
      });
      return result;
    }
  }]);

  return ProductSuppliersGroupConverterImpl;
}(ProductSuppliersGroupConverter_1.ProductSuppliersGroupConverter);

exports.ProductSuppliersGroupConverterImpl = ProductSuppliersGroupConverterImpl;